import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=5c132852"
import script from "./StatusSelector.vue?vue&type=script&lang=js"
export * from "./StatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports